import { render, staticRenderFns } from "./PhotoboothComponentScreen.vue?vue&type=template&id=a643d160&scoped=true&"
import script from "./PhotoboothComponentScreen.vue?vue&type=script&lang=js&"
export * from "./PhotoboothComponentScreen.vue?vue&type=script&lang=js&"
import style0 from "./PhotoboothComponentScreen.scss?vue&type=style&index=0&id=a643d160&prod&lang=scss&scoped=true&"
import style1 from "./PhotoboothComponentScreen.vue?vue&type=style&index=1&id=a643d160&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a643d160",
  null
  
)

export default component.exports